import { useFilePreview } from '@atlaskit/media-file-preview';
import React from 'react';
export var MediaImageV2Base = function MediaImageV2Base(_ref) {
  var identifier = _ref.identifier,
    _ref$apiConfig = _ref.apiConfig,
    apiConfig = _ref$apiConfig === void 0 ? {} : _ref$apiConfig,
    children = _ref.children,
    ssr = _ref.ssr;
  var width = apiConfig.width,
    height = apiConfig.height,
    mode = apiConfig.mode,
    allowAnimated = apiConfig.allowAnimated,
    upscale = apiConfig.upscale,
    maxAge = apiConfig['max-age'];
  var dimensions = {
    width: width,
    height: height
  };
  var _useFilePreview = useFilePreview({
      identifier: identifier,
      dimensions: dimensions,
      ssr: ssr,
      resizeMode: mode,
      allowAnimated: allowAnimated,
      upscale: upscale,
      maxAge: maxAge
    }),
    preview = _useFilePreview.preview,
    error = _useFilePreview.error,
    getSsrScriptProps = _useFilePreview.getSsrScriptProps;

  //----------------------------------------------------------------
  // RENDER
  //----------------------------------------------------------------

  var status = 'loading';
  if (preview !== null && preview !== void 0 && preview.dataURI) {
    status = 'succeeded';
  } else if (error) {
    status = 'error';
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, children({
    loading: status === 'loading',
    error: status === 'error',
    data: status === 'succeeded' ? {
      status: status,
      src: preview === null || preview === void 0 ? void 0 : preview.dataURI
    } : undefined
  }), getSsrScriptProps && /*#__PURE__*/React.createElement("script", getSsrScriptProps()));
};